export default __webpack_public_path__ + "static/media/asian-g29979ad92_640.9f87844c.jpg";